<template>
    <div class="animated fadeIn timing_kc">
        <filters :scope="filtersScope">
        </filters>
                <div class="statistic-wrap" v-if="this.checkForking.length > 0" >
                <div class="card statistic-table">
                        <div>
                            <div class="card-block" v-for="(rows, i) in data">
                                <table class="table">
                                    <thead>
                                    <div class="wrapper-title">
                                        <tr class="main-tr">
                                            <th>Дата<br>{{rows.date}}</th>
                                        </tr>
                                        <div class="titles">
                                            <tr>
                                                <th>Часы(местное время)</th>
                                                <th>Часы (мск)</th>
                                                <th>Лиды</th>
                                                <th>% от общего</th>
                                                <th>Апрув лиды</th>
                                                <th>Апрув за час</th>
                                                <th>Апрув<br>накопительный</th>
                                                <th>Апрув от валида</th>
                                            </tr>
                                        </div>
                                    </div>
                                    </thead>
                                    <tbody>
                                    <tr class="tr-data"
                                        v-for="row in rows.data"
                                        :style="rows.time.indexOf(parseInt(row.local_period)) !== -1 ? 'background-color: rgb(200, 230, 201);' : ''"
                                    >
                                        <td  :style="renderBackground(row)" :class="getClasses(row)">
                                            {{row.local_period}}
                                        </td>
                                        <td>
                                            {{row.moscow_period}}
                                        </td>
                                        <td>
                                            {{row.total}}
                                        </td>
                                        <td>
                                            {{(row.total_percent).toFixed(1)}} %
                                        </td>
                                        <td>
                                            {{row.approved}}
                                        </td>
                                        <td>
                                            {{(row.approved_percent).toFixed(1)}} %
                                        </td>
                                        <td>
                                            {{(row.approved_accumulated_percent).toFixed(1)}} %
                                        </td>
                                        <td>
                                          {{approvedFromValid(row.approved, row.total, row.spam)}}
                                        </td>
                                    </tr>
                                    </tbody>

                                    <tfoot class="table-footer">
                                    <tr>
                                        <th>Итого</th>
                                    </tr>
                                    <tr>
                                        <td>{{rows.data.total_per_day}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{(rows.data.working_percent).toFixed(1)}} %</td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>Смены для этой страны не выставлены...</div>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters'
  import API from '../../../api/API'
  import StatisticTable from '../../../components/StatisticTable'
  import {map} from 'lodash'

  export default {
    components: {
      StatisticTable,
      Filters
    },
    data () {
      return {
        filtersScope: {
          countryFilter: true,
          dateFilter: true,
          offerFilter: true,
          byWmFilter: true,
          oneCountryFilter: true
        },
        data: [],
        x: 0,
        checkForking: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      approvedFromValid (approved, total, spam) {
        return `${((approved / (total - spam)) * 100).toFixed(1)}%`
      },
      onSwipe (e) {
        const offset = document.getElementById('swipe').offsetWidth
        const scroll = document.getElementById('swipe').scrollWidth
        const width = scroll - offset
        if (width > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10
          } else {
            this.x -= e.distance / 10
          }
          if (this.x > 0) {
            this.x = 0
          }
          if (Math.abs(this.x) > width) {
            this.x = -width
          }
        }
      },
      renderBackground (td) {
        let local = parseInt(td.local_period)
        if (local === 0 || local < 6) {
          return 'background-color: rgb(144, 202, 249);'
        }
        if (local === 7 || local < 11) {
          return 'background-color: rgb(255, 249, 196);'
        }
        if (local === 12 || local < 16) {
          return 'background-color: rgb(255, 217, 106);'
        }
        if (local === 17 || local <= 23) {
          return 'background-color: rgb(186, 224, 255);'
        }
      },
      getClasses (td) {
        let local = parseInt(td.local_period)
        let classes = []
        if (local === 0) {
          classes.push('td-time night')
        }
        if (local === 6) {
          classes.push('td-time morning')
        }
        if (local === 11) {
          classes.push('td-time day')
        }
        if (local === 16) {
          classes.push('td-time evening')
        }
        return classes
      },
      async calculateRows () {
        this.$root.$emit('data_loading')
        this.data = []
        let dataItems = []
        let totalItems = []
        let time = []
        await API.getWorkTimingKC().then(response => {
          this.checkForking = []
          dataItems = response.body.data
          totalItems = response.body.totals
          time = response.body.working_time
          this.checkForking = response.body.working_time
          let hourse = []
          let inTime = []
          for (let i = 0; i < 24; i++) {
            hourse.push(i)
          }

          for (let i = 0; i < time.length; i++) {
            let from = parseInt(time[i].time_from)
            let to = parseInt(time[i].time_to)
            if (from > to) {
              inTime.push(...hourse.slice(from).concat(hourse.slice(0, to)))
            } else {
              inTime.push(...hourse.slice(from, to))
            }
          }

          for (let keyItems in dataItems) {
            for (let keyTotal in totalItems) {
              if (keyTotal === keyItems) {
                dataItems[keyItems].total_per_day = totalItems[keyTotal].total_per_day
                dataItems[keyItems].working_percent = totalItems[keyTotal].working_percent
              }
            }
          }
          let rezult = []
          for (let i in dataItems) {
            rezult.push({
              date: i,
              data: dataItems[i],
              time: inTime
            })
          }
          let newRezult = rezult.sort((a, b) => {
            if (a.date > b.date) {
              return 1
            } else if (a.date < b.date) {
              return -1
            } else {
              return 0
            }
          })
          this.data = newRezult
        })
        this.$root.$emit('data_loaded')
      }
    }
  }
</script>

<style scoped>
    .table {
        display: flex;
        margin-top: 20px;
    }

    tbody {
        display: flex;
    }
    tfoot tr th {
        height: 60px;
    }
    tfoot td{
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    tbody td {
        width: 55px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 5px;
    }

    tr {
        display: flex;
        flex-direction: column;
    }

    .wrapper-title {
        display: flex;
    }

    .wrapper-title tr th {
        border-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        height: 60px;
        font-size: 13px;
    }

    .main-tr {
        width: 90px;
        border-right: 1px solid #ccc;
    }

    .card-block {
        margin-top: 20px;
    }

    .table-footer th {
        background-color: #ccc;
        font-weight: 400;
        height: 120px;
        display: flex;
        align-items: center;

    }
    .titles tr th {
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .night, .morning, .day, .evening {
        position: relative;
        display: flex;
    }
    .td-time:before {
        position: absolute;
        top: -35px;
        font-size: 16px;
        left: 0;
        width: 110px;
        height: 35px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
    }
    .td-time.night:before {
        content: 'Ночь';
        background-color: rgb(144, 202, 249);
    }
    .td-time.morning:before {
        content: 'Утро';
        background-color: rgb(255, 249, 196);
    }
    .td-time.day:before {
        content: 'День';
        background-color: rgb(255, 217, 106);
    }
    .td-time.evening:before {
        content: 'Вечер';
        background-color: rgb(186, 224, 255);
    }
</style>



// WEBPACK FOOTER //
// WorkTimingKC.vue?c7e574ba